import { authStoreUserTournamentId } from 'modules/auth/store/selectors';
import { useGetActivePaidSubscriptionQuery } from 'modules/organizer/store/organizer-plan-api';
import { useSelector } from 'react-redux';

/**
 * Оплаченная подписка текущей организации (RTK Query, тег `Organizer` — сбрасывается покупкой тарифа).
 *
 * `isFetching` / `isLoading` — «данных для этой организации ещё нет»: фоновый перезапрос после оплаты их не
 * поднимает, и страницы локаций не мигают загрузкой.
 */
export function useFetchActivePlan() {
  const organizerId = useSelector(authStoreUserTournamentId);
  const skip = !organizerId;

  const query = useGetActivePaidSubscriptionQuery(organizerId as number, { skip });
  // `currentData`, а не `data`: при смене организации `data` ещё держит подписку прежней.
  const data = query.currentData;
  const isPending = !skip && data === undefined && query.isFetching;

  return {
    data,
    isFetching: isPending,
    isLoading: isPending,
  };
}
